import {
  StatusDeleted,
  StatusDraft,
  StatusPublished,
  LoadingStatusIdle,
  LoadingStatusPending,
  LoadingStatusResolved,
  LoadingStatusRejected,
} from 'interfaces';

export const STATUS: {
  DELETED: StatusDeleted;
  DRAFT: StatusDraft;
  PUBLISHED: StatusPublished;
} = Object.freeze({
  DELETED: 'deleted',
  DRAFT: 'draft',
  PUBLISHED: 'published',
});

export const LOADING_STATUS: {
  IDLE: LoadingStatusIdle;
  PENDING: LoadingStatusPending;
  RESOLVED: LoadingStatusResolved;
  REJECTED: LoadingStatusRejected;
} = Object.freeze({
  IDLE: 'idle',
  PENDING: 'pending',
  RESOLVED: 'resolved',
  REJECTED: 'rejected',
});
